import { Dropdown } from '@schibsted-svp/react-ui';

import { overrideProvider } from '../../../services/svpProvider';

import type { FC, ReactNode } from 'react';
import type { Provider } from '../../../types';

type Props = {
  children?: ReactNode;
};

const ProviderSelect: FC<Props> = ({ children }) => {
  const options = [
    {
      value: 'vgtv',
      label: 'VGTV',
    },
    {
      value: 'ab',
      label: 'ABTV',
    },
    {
      value: 'brandstudio',
      label: 'BrandStudio',
    },
  ];

  return (
    <Dropdown leftButtonRenderer={() => children}>
      {options.map((option) => (
        <Dropdown.Item
          key={option.value}
          itemKey={option.value}
          onClick={() => overrideProvider(option.value as Provider)}
        >
          {option.label}
        </Dropdown.Item>
      ))}
    </Dropdown>
  );
};

export { ProviderSelect };
